import React, { useState, useEffect } from "react"
import { ArrowRight, TrendingUp, Shield, Zap } from "lucide-react";

function Hero() {

  const [activeIndex, setActiveIndex] = useState(0)
  const features = [
    { icon: <TrendingUp className="w-6 h-6" />, text: "Real-time market analysis" },
    { icon: <Shield className="w-6 h-6" />, text: "Bank-grade security" },
    { icon: <Zap className="w-6 h-6" />, text: "Lightning-fast transactions" },
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % features.length)
    }, 3000)
    return () => clearInterval(timer)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className="relative bg-primary text-white py-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1639322537228-f710d846310a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1920&q=80"
          alt="Crypto background"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-blue-900 opacity-50"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-extrabold mb-6 leading-tight">
            Invest in the <span className="text-yellow-400">Future</span> of Finance
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-blue-100">
            Join thousands of investors building their wealth with cryptocurrencies
          </p>
          <div className="flex justify-center space-x-4 mb-12">
            <button className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full text-lg font-semibold hover:bg-yellow-300 transition-colors shadow-lg flex items-center">
              Start Investing Now
              <ArrowRight className="ml-2 w-5 h-5" />
            </button>
            <button onClick={() => window.location.href='/login'}  className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors shadow-lg">
             Login to continue
            </button>
          </div>
          <div className="flex justify-center items-center space-x-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`flex items-center space-x-2 transition-opacity duration-500 ${
                  index === activeIndex ? "opacity-100" : "opacity-50"
                }`}
              >
                {feature.icon}
                <span className="text-sm md:text-base">{feature.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-primaryx to-transparent"></div>
    </section>
  )
}

export default Hero

